<template>
    <div class="ui-core-dynamic-components">
        <template v-for="(dynamicComponent, index) in blok.dynamicComponents" :key="dynamicComponent._uid">
            <template
                v-if="
                    dynamicComponent.eventName === activeEvent || (!activeEvent && blok.displayDefault && index === 0)
                "
            >
                <Component :is="dynamicComponent.component" :blok="dynamicComponent" />
            </template>
        </template>
    </div>
</template>

<script setup lang="ts">
import type {
    ICoreDynamicComponents,
    ICoreEventComponent,
} from '@nuxt-monorepo/ui/types/components/CoreDynamicComponents';
import { useEventBus } from '@vueuse/core';

const { blok } = defineProps<{ blok: ICoreDynamicComponents }>();
const activeEvent = ref('');

blok.dynamicComponents.forEach((item: ICoreEventComponent) => {
    const eventBus = useEventBus(item.eventName);
    eventBus.on(() => {
        activeEvent.value = item.eventName;
    });
});
</script>

<style scoped lang="postcss"></style>
